import { apiClient } from "@/lib/api-client";

export const postValidationStatus = async ({
  year,
  semester,
  niu,
  is_validator,
  payload,
}: {
  year: number | string;
  semester: number | string;
  niu: string;
  is_validator: boolean;
  payload: {
    per_unsur_status: any;
  };
}) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    niu: niu,
    is_validator: is_validator.toString(),
  });

  const res = await apiClient<any>(
    `${baseUrl}/api/v1/validation-status?${params.toString()}`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );

  return res;
};
